(function() {
'use strict';

angular
    .module('TR')
    .directive('hotelStats', HotelStats);

function HotelStats(arrayUtil, urgencyMessaging, toaster) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            model: '='
        },
        template: '<div><div>',
        link(scope) {
            if (TRPCONFIG.Domain.UrgencyMessaging) {
                urgencyMessaging.get(scope.model).then(function(stats) {
                    if (stats != null) {
                        const msgs = arrayUtil.filter([stats.CurrentViewsText, stats.LastBookedDateText], function(msg) {
                            return msg != null;
                        });

                        angular.forEach(msgs, function(msg) {
                            toaster.pop('info', msg);
                        });
                    }
                });
            }
        }
    };
}
})();
